<template>
  <v-layout>
    <div class="md:flex md:justify-center">
      <div class="md:w-full mx-32">
        <div>
          <div class="md:px-4 w-full">
            <div>
              <v-expansion-panels accordion>
                <v-expansion-panel v-for="(item, i) in purpose_list" :key="i">
                  <v-expansion-panel-header>
                    {{ item.title }}
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div v-for="(item, j) in item.child" :key="j">
                      <v-checkbox
                        class="shrink h-8"
                        v-model="selected_purposes"
                        :label="item.title"
                        :value="item"
                      ></v-checkbox>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
          <!-- <pre>
            {{ selected_purposes }}
          </pre> -->
        </div>
      </div>
    </div>
  </v-layout>
</template>

<script>
// import axios from "axios";
export default {
  data() {
    return {
      purpose_list: [
        {
          id: "claim",
          title: "Claim my documents",
          child: [
            { title: "Refund Check", id: 1, subject: "Claim my documents" },
            {
              title: "Certificate of Full Payment",
              id: 2,
              subject: "Claim my documents",
            },
            {
              title: "Title and Tax Declaration Under Buyer’s Name",
              id: 3,
              subject: "Claim my documents",
            },
            {
              title: "Copy of Tax Declaration Under Moldex",
              id: 4,
              subject: "Claim my documents",
            },
            {
              title: "Copy of Title Under Moldex",
              id: 5,
              subject: "Claim my documents",
            },
            {
              title: "Transfer of Rights",
              id: 6,
              subject: "Claim my documents",
            },
            {
              title: "Deed of Absolute Sale",
              id: 7,
              subject: "Claim my documents",
            },
            { title: "Contract to Sell", id: 8, subject: "Claim my documents" },
            {
              title: "Statement of Account",
              id: 9,
              subject: "Claim my documents",
            },
            {
              title: "Official Receipt",
              id: 10,
              subject: "Claim my documents",
            },
          ],
        },
        {
          id: "submit",
          title: "Submit my documents",
          child: [
            {
              title: "Contract to Sell requirements",
              id: 11,
              subject: "Submit my documents",
            },
            {
              title: "Deed of Absolute Sale / Title transfer requirements",
              id: 12,
            },
            {
              title: "Transfer of Rights / Change Name requirements",
              id: 13,
              subject: "Submit my documents",
            },
            {
              title: "To comply with my special request/s",
              id: 14,
              subject: "Submit my documents",
            },
            {
              title: "Notarized & Consularized Special Power of Attorney",
              id: 15,
              subject: "Submit my documents",
            },
            { title: "Valid I.D.", id: 16, subject: "Submit my documents" },
            {
              title: "Marriage contract",
              id: 17,
              subject: "Submit my documents",
            },
            {
              title: "Extrajudicial Settlement of Estate",
              id: 18,
              subject: "Submit my documents",
            },
            {
              title: "Affidavit of Waiver",
              id: 19,
              subject: "Submit my documents",
            },
            {
              title: "Verified T.I.N.",
              id: 20,
              subject: "Submit my documents",
            },
          ],
        },
        {
          id: "sign",
          title: "Sign my documents",
          child: [
            { title: "Contract to Sell", id: 21, subject: "Sign my documents" },
            {
              title: "Deed of Absolute Sale",
              id: 22,
              subject: "Sign my documents",
            },
            {
              title: "Transfer of Rights",
              id: 23,
              subject: "Sign my documents",
            },
            {
              title: "House Layout and Perspective",
              id: 24,
              subject: "Sign my documents",
            },
          ],
        },
        {
          id: "payment_concerns",
          title: "Payment concerns",
          subject: "Payment concerns",
        },
      ],
      book_appointment_purpose_sub: [],
      radioGroup: 1,
      purpose: [],
      selected_purposes: [],
      sub_purpose_selected: "",
      sub: [],
    };
  },
  watch: {
    selected_purposes: {
      handler() {
        this.$emit("purpose_selected", this.selected_purposes);
      },
      immediate: true,
    },
  },
};
</script>
